import {
  Button as TButtonFrame,
  ButtonIcon,
  ButtonText,
  ButtonProps as TButtonProps,
  styled,
  withStaticProperties,
  GetProps,
} from 'tamagui'

const ButtonFrame = styled(TButtonFrame, {
  paddingHorizontal: '$1',
  borderRadius: '$true',
  borderColor: '$borderColor',
  variants: {
    variant: {
      secondary: {
        theme: 'secondary',
      },
    },
    circular: {
      true: {
        borderRadius: 100_000,
      },
    },
  },
})

type ButtonProps = GetProps<typeof ButtonFrame> & {
  variant?: Omit<GetProps<typeof ButtonFrame>['variant'], 'outlined'>
}

// force variant to be 'secondary' rather than outlined
const ButtonComponent = ButtonFrame.styleable<ButtonProps>((props, ref) => (
  <ButtonFrame {...(props as unknown as TButtonProps)} ref={ref} />
))

export const Button = withStaticProperties(ButtonComponent, { Text: ButtonText, Icon: ButtonIcon })

export type { ButtonProps }

export { ButtonText, ButtonIcon }
